@if (chartsCountSg() === 1) {
  <!-- In case that there is only one chart, we want to display it on whole
  widget, and to avoid calculations for grid layout, only one chart is displayed
  without any classes-->
  <atn-ds-chart [chart]="chartsSg()[0]" />
} @else {
  <div
    #scatterChartsContainer
    class="scatter-chart-grid-container"
    [style.--scatter-chart--min-width]="minWidth"
    [style.--scatter-chart--min-height]="minHeight"
    [style.--scatter-charts--max-columns]="columnsCountSg()"
    [style.--scatter-charts--rows]="rowsCountSg()"
    [style.--scatter-chart--container-height]="containerHeightSg()"
  >
    @for (chart of chartsSg(); track $index) {
      <atn-ds-chart [chart]="chart" />
    }
  </div>
}
